const NAMESPACE = "sharedFormElementWords";

const KEYS = {
    selectDefaultValue: "selectDefaultValue"
};

const MESSAGES = {
    [KEYS.selectDefaultValue]: {
        value: "Select...",
        comment: "Prompt for user to select a value"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
